var map = {
	"./banner/HomePage-IT.webp": 1079,
	"./banner/HomePage-agencies.webp": 1080,
	"./banner/HomePage-banks.webp": 1081,
	"./banner/HomePage-elearning.webp": 1082,
	"./banner/HomePage-foods.webp": 1083,
	"./banner/HomePage-industries.webp": 1084,
	"./banner/HomePage-innovation.webp": 1085,
	"./banner/HomePage-insurance.webp": 1086,
	"./banner/HomePage-manufacturing-firms.webp": 1087,
	"./banner/HomePage-media.webp": 1088,
	"./banner/HomePage-universities.webp": 1089,
	"./banner/Khandevane.png": 1090,
	"./banner/sunich.png": 1091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1134;